import {FieldType} from './global.model';

export enum ControlTypeEnum {
    Checkbox = 1,
    ComboList = 2,
    Text = 3,
    TextArea = 4,
    Date = 5,
    RadioButton = 6,
    Phone = 7,
    Email = 8,
    File = 9,
    SvcCmp = 10,
    Label = 11,
    Avis = 12,
}

export interface OptionCommon {
    controlType: FieldType;
    icon: string;
    tooltip: string;
    label: string;
    isRequired: boolean;
    placeholder?: string;
}

export interface OptionText extends OptionCommon {
    maxlength?: number;
}

export interface OptionDate extends OptionCommon {
    minDate?: Date;
    maxDate?: Date;
    publicDays?: boolean;
    holidays?: boolean;
    closedDays?: boolean;
    saturday?: boolean;
    sunday?: boolean;
    monday?: boolean;
    tuesday?: boolean;
    wednesday?: boolean;
    thursday?: boolean;
    friday?: boolean;
}

export interface OptionCheckbox  extends OptionCommon {
    horizontal: boolean;
    options: any[]; // là aussi, cela pourrait être typé, à voir
    // le reste
}

export interface OptionRadio extends OptionCommon {
  horizontal: boolean;
  options: any[];
}

export interface OptionSvcCmp extends OptionCommon {
  entite: number;
  options: any[];
}

export interface OptionsLabel extends OptionCommon {
  content: string;
}

export interface OptionsAvis extends OptionCommon {
  typeAvis: number;
}

export interface Control {
    type: ControlTypeEnum;
    nom: string;
    description: string;
    hidden?: boolean;
    options?: OptionText | OptionCheckbox | OptionDate | OptionRadio | OptionSvcCmp | OptionsLabel | OptionsAvis;
}
